import { render, staticRenderFns } from "./RoAttributeExtensionUpdateEvent.vue?vue&type=template&id=18ce8be2&scoped=true&"
import script from "./RoAttributeExtensionUpdateEvent.vue?vue&type=script&lang=js&"
export * from "./RoAttributeExtensionUpdateEvent.vue?vue&type=script&lang=js&"
import style0 from "./RoAttributeExtensionUpdateEvent.vue?vue&type=style&index=0&id=18ce8be2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ce8be2",
  null
  
)

export default component.exports